import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../../common/formElements/CustomSelect';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import fieldOptions from './FieldOptionsData';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XanoTableSchema extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedCollectionId: 0,
    resultColl: {},
    fieldDatatypes: [],
    apitabledata: {},
    upid: null,
    selectedPrimaryKey: 'id',
  };

  async componentDidMount() {
    const { dbUuid, projectId, version } = this.props.match.params;
    const { location, actions } = this.props;
    await actions.getStoredXanoData({ projectId, dbUuid, version });
    const { completeData, uuid } = this.props.dataConnector.xanoStoredData;
    this.setState({ apitabledata: completeData });
    this.setState({ upid: uuid });
    const { tables } = completeData ? completeData : [];
    if (location.state.collectionid) {
      this.setState({ selectedCollectionId: location.state.collectionid });
      this.handleCollection(this.state.selectedCollectionId);
    } else {
      if (tables && tables.length > 0) {
        const firstCollectionId = tables[0].id;
        this.handleCollection(firstCollectionId);
      }
    }
  }

  handleCollection = async (idcol) => {
    const { projectId, version } = this.props.match.params;
    const { completeData } = this.props.dataConnector.xanoStoredData;
    const { workspace, tables } = completeData;
    const { token } = this.props.location.state;
    await this.props.actions.xanoSchema({
      token,
      workspaceId: workspace.id,
      idcol,
      projectId,
      version,
    });
  };
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0].name] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  handleFormSubmit = async (values) => {
    const { workspace, tables } = this.state.apitabledata;
    const { setting, name } = this.props.dataConnector.xanoStoredData;
    const { fieldDatatypes, selectedPrimaryKey } = this.state;
    const { upid } = this.state;
    const newArray = this.props.dataConnector.getXanoSchemaData.filter((element, index) => {
      if (index !== 0 && index !== 1) {
        return element;
      }
    });
    const result = {};
    newArray.forEach((item) => {
      const fieldValue = fieldDatatypes[item.name] || (item.type === 'int' ? 'number' : item.type);
      result[item.name] = fieldValue;
    });
    let idx = tables.findIndex((item) => item.id === this.state.selectedCollectionId);
    const collectionName = idx === -1 ? tables[0].name : tables[idx].name;
    const objectIdToUpdate = idx === -1 ? tables[0].id : tables[idx].id;
    const newresult = {};
    for (const key in result) {
      if (result.hasOwnProperty(key)) {
        newresult[key] = result[key] === 'int' ? 'number' : result[key];
      }
    }
    const { projectId, dbUuid, version } = this.props.match.params;
    const savefieldsobj = {
      fieldsToUpdate: newresult,
      objectIdToUpdate,
      collectionTitle: values.collectionTitle,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
    };
    await this.props.actions.saveXanoFields({ savefieldsobj, projectId, upid, version });
    const data = {
      collectionName: collectionName,
      collectionTitle: values.collectionTitle,
      orgCollectionName: collectionName,
      willPersist: false,
      fields: newresult,
      projectId,
      externalDatabaseId: dbUuid,
      tableId: objectIdToUpdate,
      workspaceId: workspace.id,
      setting,
      version: version,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
      name: name ? name : '',
    };
    const savecoll = await this.props.actions.createCollectionfromXano({
      projectId,
      version,
      data,
    });
    this.setState({ resultColl: savecoll });

    if (this.props.location.state.collectionid) {
      this.props.history.push(
        `/2.0/data-connector/${version}/v/${projectId}/external-database-edit/${upid}`,
      );
    } else {
      if (tables.length - 1 == idx) {
        this.props.history.push(`/2.0/collections/${version}/v/${projectId}`);
      }
    }
  };
  handleSkip = () => {
    const { upid } = this.state;
    const { projectId, version } = this.props.match.params;
    let currentIndex = this.state.apitabledata.tables.findIndex(
      (item) => item.id === this.state.selectedCollectionId,
    );
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < this.state.apitabledata.tables.length) {
      const nextCollectionId = this.state.apitabledata.tables[nextIndex].id;
      this.handleCollection(nextCollectionId);
      this.setState({ selectedCollectionId: nextCollectionId });
    }

    if (this.props.location.state.collectionid) {
      this.props.history.push(
        `/2.0/data-connector/${version}/v/${projectId}/external-database-edit/${upid}`,
      );
    } else {
      if (this.state.apitabledata.tables.length - 1 == currentIndex) {
        this.props.history.push(`/2.0/collections/${version}/v/${projectId}`);
      }
    }
  };
  handleSaveAndContinue = async (values) => {
    await this.handleFormSubmit(values);
    const { tables } = this.state.apitabledata;
    let currentIndex = tables.findIndex((item) => item.id === this.state.selectedCollectionId);
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < tables.length) {
      const nextCollectionId = tables[nextIndex].id;
      if (this.state.resultColl.data) {
        await this.handleCollection(nextCollectionId);
        this.setState({ selectedCollectionId: nextCollectionId });
      }
    }
  };
  handleRadioChange = (fieldName) => {
    this.setState({ selectedPrimaryKey: fieldName }, () => {});
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { apitabledata, selectedCollectionId, colnam } = this.state;
    const { tables } = apitabledata;
    const { dataConnector } = this.props;
    const { getXanoSchemaData, xanoSchemaPending, saveXanoFieldsPending } = dataConnector;
    const filterFields = (fields) => {
      return fields.filter((header) => header.name !== 'id' && header.name !== 'created_at');
    };
    if (this.state.apitabledata.tables) {
      var curidx = this.state.apitabledata.tables.findIndex(
        (item) => item.id === selectedCollectionId,
      );
      var colname = curidx === -1 ? tables[0].name : tables[curidx].name;
    }
    if (xanoSchemaPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={xanoSchemaPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }

    return this.state.apitabledata ? (
      <CommonPageComponent>
        <ParentContentCard
          title="Choose This Collection for Create Or Skip via Xano"
          icon="collection"
        >
          <Formik initialValues={{ collectionTitle: colname }} enableReinitialize={true}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-12 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Xano collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={colname}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          <th style={{ width: '12%' }}>Primary Key</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterFields(getXanoSchemaData).map((header, index) => (
                          <tr key={index}>
                            <td>{header.name}</td>
                            <td>
                              <CustomSelect
                                name={header}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={fieldOptions}
                                value={this.state.fieldDatatypes[header.name] || header.type}
                              />
                            </td>
                            <td style={{ width: '12%' }}>
                              <div className="form-check ml-4 pl-3">
                                <CustomRadio label="" isRadio={false}>
                                  <Field
                                    type="checkbox"
                                    name={header.name}
                                    className="form-check-input"
                                    checked={this.state.selectedPrimaryKey === header.name}
                                    onChange={() => this.handleRadioChange(header.name)}
                                  />
                                </CustomRadio>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleSkip}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      onClick={() => this.handleSaveAndContinue(values)}
                    >
                      <i className="wb webconnect-save-regular"></i> Save & Continue
                      <CustomLoader loading={saveXanoFieldsPending || xanoSchemaPending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoTableSchema);
